<template>
  <div class="proposed_route">
    <div class="title">
      返程推荐 <span>返程推荐路线</span>
    </div>
    <div class="route_info">
      <div class="info_title">车辆返程信息</div>
      <div class="route">
        <div>
          <span>返程路线：</span>
        </div>
        <div>
          <span></span>
          {{data.goodsAddress}}
        </div>
        <div>
          <span></span>
          {{data.region}}{{data.address}}
        </div>
        <div>
          <span>车辆当前位置： </span>
          {{data.addressName}} <p @click="handleShowTrack">查看地图</p>
        </div>
        <div class="showCarInfo"><span @click="showCarInfo=!showCarInfo"
                v-bind:class="showCarInfo?'active':''">车辆信息</span></div>
        <ul class="carInfo"
            v-show="showCarInfo">
          <li><span>公司姓名：</span>{{data.companyName}}</li>
          <li>
            <span>罐体材质：</span>
            <p v-if="data.materialTank==='01'">铝罐</p>
            <p v-else-if="data.materialTank==='02'">铁罐</p>
            <p v-else-if="data.materialTank==='03'">白钢罐</p>
            <p v-else-if="data.materialTank==='04'">铝合金罐</p>
          </li>
          <li><span>设备编码：</span>{{data.equipmentId}}</li>
          <li><span>车头号：</span>{{data.headNumber}}</li>
          <li><span>司机姓名：</span>{{data.dirverName}} </li>
          <li><span>备案介质：</span>{{data.mediumClass}} </li>
          <li><span>司机电话：</span>{{data.dirverPhone}} </li>
          <li><span>荷载量：</span>{{data.nuclearLoadTonnage}}吨 </li>
          <li>
            <span>车辆状态：</span>
            <p v-if="data.vehicleState==='01'">空车</p>
            <p v-else-if="data.vehicleState==='02'">待运输</p>
            <p v-else-if="data.vehicleState==='03'">重车</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="route_list">
      <el-tabs v-model="activeName"
               class="route_list_title"
               @tab-click="handleListClick(activeName)">
        <el-tab-pane :label="'返程推荐线路('+routeLength+')'"
                     name="0"></el-tab-pane>
        <el-tab-pane label="返程线路地图"
                     name="1"></el-tab-pane>
      </el-tabs>
      <div class="proposedStatus">推荐状态:
        <span>进行中</span>
        <!-- <span v-if="data.schedule === '01'">进行中</span>
              <span v-else-if="data.schedule === '02'">推荐完成</span>
              <span v-else-if="data.schedule === '03'">已取消</span> -->
      </div>
      <div class="search_range">
        <el-select v-model="resourceSelect"
                   @change="getRouteList"
                   slot="prepend"
                   placeholder="全部"
                   size="small">
          <el-option label="50km"
                     value="50"></el-option>
          <el-option label="100km"
                     value="100"></el-option>
          <el-option label="200km"
                     value="200"></el-option>
          <el-option label="300km"
                     value="300"></el-option>
          <el-option label="400km"
                     value="400"></el-option>
          <el-option label="500km"
                     value="500"></el-option>
          <el-option label="7000km"
                     value=7000></el-option>
        </el-select>
        <label>搜索范围：</label>
      </div>
      <div v-show="activeName === '0'"
           class="list_table">
        <el-table style="width: 100%"
                  :data="routeData.route"
                  class="order_table">
          <el-table-column fixed
                           label="序号"
                           align="center"
                           type="index"
                           width="50">
          </el-table-column>
          <el-table-column header-align="left"
                           label="返程路线"
                           align="left"
                           min-width="207px">
            <template slot-scope="scope">
              <div class="plan_route">
                <!-- <span class="checked" v-if="scope.row.checked">已选</span> -->
                <div v-for="item in scope.row.departureAddress"
                     :key="item.index">{{item}}</div>
                <!-- <div>{{scope.row.departureAddress}}</div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           header-align="left"
                           align="left"
                           width="127px">
            <template slot-scope="scope">
              <div>
                <el-button @click="handleRouteInfo(scope.row)">
                  线路详情
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-show="activeName === '1'"
           class="map_container">
        <div class="m-map">
          <div id="js-container"
               class="map">正在加载数据 ...</div>
        </div>
      </div>
    </div>

    <div class="trackMask"
         v-show="track"
         @click="handleCloseMapClick">
    </div>
    <div class="trackContainer"
         v-show="track">
      <div class="track_header">运输轨迹<span class="track_close"
              @click="handleCloseMapClick"></span></div>
      <div class="track_main">
        <div id="track_container"></div>
      </div>
    </div>
  </div>
</template>

<script src="https://webapi.amap.com/maps?v=1.4.13&key=6656a8e9810da0328783e4c374223568"></script>
<script>
// import remoteLoad from '@/utils/remoteLoad.js'

import {
  proposedRoute,
  proposedRouteInfo

} from 'apis/index'
export default {
  data () {
    return {
      driderId: '',
      addressName: '',
      supplyOfGoods: '',
      species: '',
      track: false,
      routeLength: 0,
      data: {
      },
      routeData: {},
      showCarInfo: false,
      activeName: '0',
      resourceSelect: 50,
      routelist: [],
      center: ['116.2317', '39.5427'],
      zoom: 5
    }
  },
  methods: {
    getData () { // 页面初始化，获取信息
      proposedRouteInfo({
        driverId: this.driderId,
        addressName: this.addressName,
        supplyOfGoods: this.supplyOfGoods,
        species: this.species

      }).then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data
          // console.log(this.data)
          this.getRouteList()
        }
      })
    },
    getRouteList () { //获取返程路线
      // console.log('id', this.data.dirverId,
      //   'address', this.data.addressName,
      //   'range', this.resourceSelect)
      proposedRoute({
        range: this.resourceSelect,
        addressName: this.data.addressName,
        driveId: this.data.dirverId
      }).then(res => {
        // console.log('aaaaddddd', res)
        if (res.data.code === 0) {
          // this.routeData = res.data.data
          if (res.data.data.route) {
            this.routeData = res.data.data
            // console.log(this.routeData)
            this.mapRoute()
          } else {
            this.routeLength = 0
            this.routeData = {}
            let routeMap = new AMap.Map('js-container', {
              resizeEnable: true,
              // center:["110.036562","40.592583"],
              zoom: this.zoom
            })
          }
        }
      })
    },
    handleListClick (id) { // table切换
      // console.log(id)
    },
    handleRouteInfo (item) { // 线路详情
      // console.log(item)
      // console.log(this.data.addressName)
      // console.log(item.drivedID)
      let route = ''
      item.departureAddress.forEach(element => {
        route += element + ','
      });
      route = route.substring(0, route.length - 1)
      // console.log('route',route)
      this.$router.push({
        path: '/manage/recommend/proposedRodeDetail',
        query: {
          'driverId': item.drivedID,
          'goodsIds': item.goodsIds,
          'routes': route,
          'departure': this.data.addressName,
          'goodsAddressLatlng': this.data.goodsAddressLatlng
        }
      })
    },
    handleShowTrack () { //展示轨迹
      this.track = true
      let start = this.data.goodsAddressLatlng
      let startPoint = [start.split(',')[0], start.split(',')[1]]
      let end = this.data.companyLatlng
      let endPoint = [end.split(',')[0], end.split(',')[1]]
      let trackPoint = [[this.data.driverLatlngA.split(',')[0], this.data.driverLatlngA.split(',')[1]], [this.data.driverLatlngB.split(',')[0], this.data.driverLatlngB.split(',')[1]]]
      var trackmap = new AMap.Map("track_container", {
        resizeEnable: true,
        center: trackPoint[trackPoint.length - 1],
        zoom: 9
      });
      var track_marker = new AMap.Marker({
        map: trackmap,
        position: trackPoint[0],
        icon: "http://image.jsh178.com/FmQdHrf-kE2vPHc4AxAH1xHFl0qI",
        offset: new AMap.Pixel(-2, -5),
        autoRotation: true,
        angle: -90,
      });
      // var polyline = new AMap.Polyline({
      //   map: trackmap,
      //   path: trackPoint,
      //   showDir:true,
      //   strokeColor: "#28F",  //线颜色
      //   strokeOpacity: 1,     //线透明度
      //   strokeWeight: 6,      //线宽
      //   // strokeStyle: "solid"  //线样式
      // });
      var passedPolyline = new AMap.Polyline({
        map: trackmap,
        path: trackPoint,
        strokeColor: "#28F",  //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6,      //线宽
        // strokeStyle: "solid"  //线样式
      });
      track_marker.moveAlong(trackPoint, 900000);
      var startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(25, 34),
        // 图标的取图地址
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
        // 图标所用图片大小
        imageSize: new AMap.Size(135, 40),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(-9, -3)
      });
      // 将 icon 传入 marker
      var startMarker = new AMap.Marker({
        position: startPoint,
        icon: startIcon,
        offset: new AMap.Pixel(-13, -30)
      });
      // 创建一个 icon
      var endIcon = new AMap.Icon({
        size: new AMap.Size(25, 34),
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
        imageSize: new AMap.Size(135, 40),
        imageOffset: new AMap.Pixel(-95, -3)
      });

      // 将 icon 传入 marker
      var endMarker = new AMap.Marker({
        position: endPoint,
        icon: endIcon,
        offset: new AMap.Pixel(-13, -30)
      });
      trackmap.add([startMarker, endMarker]);

    },
    handleCloseMapClick () { //关闭轨迹
      this.track = false
    },
    mapRoute () {
      this.routeLength = 0
      let routeMap = new AMap.Map('js-container', {
        resizeEnable: true,
        center: this.center,
        zoom: this.zoom
      })
      if (this.routeData.route) {
        let pointdata = this.routeData.route
        this.routeLength = pointdata.length
        // console.log('sasasasa',pointdata)
        let start = [pointdata[0].driveLatLng.split(',')[1], pointdata[0].driveLatLng.split(',')[0]]
        let end = [pointdata[0].companyLatLng.split(',')[1], pointdata[0].companyLatLng.split(',')[0]]
        this.center = start
        var startIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(25, 34),
          // 图标的取图地址
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
          // 图标所用图片大小
          imageSize: new AMap.Size(135, 40),
          // 图标取图偏移量
          imageOffset: new AMap.Pixel(-9, -3)
        })
        var endIcon = new AMap.Icon({
          size: new AMap.Size(25, 34),
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
          imageSize: new AMap.Size(135, 40),
          imageOffset: new AMap.Pixel(-95, -3)
        })
        // 将 icon 传入 marker
        var startMarker = new AMap.Marker({
          position: start,
          icon: startIcon,
          offset: new AMap.Pixel(-13, -30)
        })
        // 创建一个 icon
        var endIcon = new AMap.Icon({
          size: new AMap.Size(25, 34),
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
          imageSize: new AMap.Size(135, 40),
          imageOffset: new AMap.Pixel(-95, -3)
        })

        // 将 icon 传入 marker
        var endMarker = new AMap.Marker({
          position: end,
          icon: endIcon,
          offset: new AMap.Pixel(-13, -30)
        })
        routeMap.add([startMarker, endMarker])
        pointdata.forEach((element, index) => {
          let arrlist = []
          element.arrlist = []
          element.goodsLatLng.forEach(lnglat => {
            element.arrlist.push(start)
            element.arrlist.push([lnglat.split(',')[1], lnglat.split(',')[0]])
            element.arrlist.push(end)
          });
          var polyline = new AMap.Polyline({
            map: routeMap,
            path: element.arrlist,
            showDir: true,
            strokeColor: "#28F",  //线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 3,      //线宽
            strokeStyle: "solid"  //线样式
          });

          var text = new AMap.Text({
            text: index + 1,
            anchor: 'center', // 设置文本标记锚点
            cursor: 'pointer',
            // draggable:true,
            style: {
              'border-radius': '5px',
              'background': '#858C96',
              'width': '32px',
              'height': '20px',
              'text-align': 'center',
              'font-size': '13px',
              'color': '#fff',
              'line-height': '20px',
              'border': '1px solid transparent'
            },
            position: element.arrlist[1]
          });
          // console.log(index,element.arrlist[1])
          text.setMap(routeMap);

        });
      }

    }

  },
  mounted () {
    this.driderId = this.$route.query.driverid
    this.addressName = this.$route.query.addressName
    this.supplyOfGoods = this.$route.query.supplyOfGoods
    this.species = this.$route.query.species
    if (this.driderId && this.addressName && this.supplyOfGoods && this.species) {
      this.getData()
    }
    this.mapRoute()

  }

}
</script>

<style lang="stylus">
.proposed_route
  overflow-y auto
  .title
    padding-left 20px
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 77px #F7F9FB
    span
      color #212832
      margin-left 20px
  .route_info
    width calc(100% - 40px)
    overflow hidden
    background #fff
    margin 0 auto
    .info_title
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../../assets/images/gaoji_cheliang.png') no-repeat center left 15px
    .route
      padding-top 20px
      overflow hidden
      padding-bottom 10px
      border-bottom 1px solid #CFD5DC
      border-top 1px solid #CFD5DC
      color #212832
      div
        width 100%
        height 40px
        line-height 40px
        p
          display inline-block
          cursor pointer
          color #1B88EE
          margin-left 20px
        span
          width 168px
          text-align right
          display inline-block
          color #5E656F
        &:nth-child(1)
          background url('../../../../assets/images/09/back_line.png') no-repeat center left 83px
        &:nth-child(2)
          background url('../../../../assets/images/begin_icon.png') no-repeat center left 148px
        &:nth-child(3)
          background url('../../../../assets/images/end_icon.png') no-repeat center left 148px
      .showCarInfo
        span
          width 65px
          float right
          margin-right 60px
          text-align left
          color #1B88EE
          cursor pointer
          background url('../../../../assets/images/more_icon_down.png') no-repeat center right
          &.active
            background url('../../../../assets/images/more_icon.png') no-repeat center right
      .carInfo
        border-top 1px dashed #CFD5DC
        padding-top 30px
        overflow hidden
        li
          width 50%
          height 40px
          float left
          list-style none
          span
            width 168px
            display inline-block
            text-align right
            color #5E656F
          p
            display inline-block
  .route_list
    width calc(100% - 40px)
    overflow hidden
    background #fff
    margin 20px auto
    border-bottom 1px solid #ccc
    position relative
    .route_list_title
      width 100%
      height 46px
      line-height 46px
      font-size 12px
      color #858C96
      background #fff
      .el-tabs__nav-wrap::after
        height 1px
        bottom 1px solid transparent
      .el-tabs__item
        width 150px
        height 46px
        padding 0
        text-align center
        line-height 46px
        size12()
        color #5E656F
      .el-tabs__item.is-active
        border-bottom 2px solid #409EFF
        color #212832
      .el-tabs__active-bar
        background transparent !important
    .proposedStatus
      position absolute
      right 40px
      top 15px
      padding-left 20px
      width auto
      background url('../../../../assets/images/09/icon_start.png') no-repeat left center
      color #5E656F
      span
        color #212832
    .search_range
      width 100%
      height 60px
      .el-select
        float right
        margin 14px 20px 0 0
        .el-input
          width 110px
        .input-with-select .el-input-group__prepend
          background #fff
      label
        float right
        line-height 60px
    .list_table
      .order_table
        th
          background #e7f0f8
          .cell
            size12()
          &:nth-child(2)
            .cell
              padding-left 100px
        td
          size12()
          .plan_route
            float left
            padding-left 90px
            color #5E656F
            position relative
            div
              cursor pointer
              float left
              padding-right 50px
              background url('../../../../assets/images/01/nav_arrow.png') no-repeat center right 20px
              &:nth-last-child(1)
                background none
            .checked
              position absolute
              width 40px
              height 20px
              background #FF6F12
              left 25px
              top 6px
              font-size 12px
              color #ffffff
              border-radius 3px
              text-align center
              line-height 20px
          .el-button
            padding 6px 14px
            background #1B88EE
            color #fff
            font-size 12px
            border 1px solid #1B88EE
    .map_container
      width 100%
      height 453px
      background #fff
      .m-map
        width 100%
        height 100%
        .amap-container
          height 100%
  .trackMask
    position fixed
    top 0
    bottom 0
    left 0
    right 0
    background rgba(0, 0, 0, 0.4)
    z-index 200
  .trackContainer
    width 688px
    z-index 201
    height 446px
    position fixed
    top 50%
    left 50%
    margin-left -344px
    margin-top -223px
    background #fff
    .track_header
      width 100%
      height 42px
      background #1B88EE
      text-indent 1em
      line-height 42px
      font-size 16px
      color #fff
      .track_close
        width 42px
        height 42px
        background url('../../../../assets/images/01/close_icon.png') no-repeat center center
        cursor pointer
        position absolute
        right 0px
        &:hover
          background url('../../../../assets/images/01/tanluang_close.png') no-repeat center center
    .track_main
      width calc(100% - 20px)
      margin 10px auto
      height calc(100% - 62px)
      #track_container
        height 100%
</style>
